import { createContext, useState, useEffect } from "react";

// Create Context
export const AppContext = createContext();

const tabsData = [
  { id: 0, label: "Forecast" },
  { id: 1, label: "Consensus" },
  { id: 2, label: "Fcst Accuracy" },
]
// Create Provider Component
export const AppProvider = ({ children }) => {
  const [toggle, setToggle] = useState("false");
  const [activeTab, setActiveTab] = useState(tabsData[0]?.id || 0);
  const [allcollapse, setAllcollapse] = useState(true);
  const [PastActualsOneValue, setPastActualsOneValue] = useState(true)
  const [PastActualsTwoValue, setPastActualsTwoValue] = useState(true)
  const [PastForecastOneValue, setPastForecastOneValue] = useState(true)
  const [PastForecastTwoValue, setPastForecastTwoValue] = useState(true)
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  useEffect(() => {
    if (theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);
  const [editingInputsValues, setEditingInputsValues] = useState([]);
  const [projectedValues, setProjectedValues] = useState([]);
  const [projectedValuesLoaded, setProjectedValuesLoaded] = useState(false)
  const [versionWeekNo, setVersionWeekNo] = useState(null);
  const [projectedMonthlyAggregationEdited, setProjectedMonthlyAggregationEdited] = useState({});
  const [aggregationsUnionArr, setAggregationsUnionArr] = useState([])

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };
  const PastActualsOneFunc = () => {
    setPastActualsOneValue(!PastActualsOneValue)

  }
  const PastActualsTwoFunc = () => {
    setPastActualsTwoValue(!PastActualsTwoValue)
  }
  const PastForecastOneFunc = () => {
    setPastForecastOneValue(!PastForecastOneValue)
  }
  const PastForecastTwoFunc = () => {
    setPastForecastTwoValue(!PastForecastTwoValue)
  }


  return (
    <AppContext.Provider value={{
      activeTab, setActiveTab,
      toggle, setToggle,
      allcollapse, setAllcollapse,
      theme, toggleTheme,
      PastActualsOneValue, PastActualsOneFunc,
      PastActualsTwoValue, PastActualsTwoFunc,
      PastForecastOneValue, PastForecastOneFunc,
      PastForecastTwoValue, PastForecastTwoFunc,
      projectedValues, setProjectedValues,
      projectedValuesLoaded, setProjectedValuesLoaded,
      editingInputsValues, setEditingInputsValues,
      versionWeekNo, setVersionWeekNo,
      projectedMonthlyAggregationEdited, setProjectedMonthlyAggregationEdited,
      aggregationsUnionArr, setAggregationsUnionArr
    }}>
      {children}
    </AppContext.Provider>
  );
};
